// Эти две константы должны быть определены в самом начале файла
// повторяющиеся части не выносить в отдельную константу
// иначе webpackContext не сможет найти модули
const serviceComponentsWebpackContext = import.meta.webpackContext('@/components/services', {
  recursive: true,
  regExp: /\.js$/
})
const templateComponentsWebpackContext = import.meta.webpackContext('@/components/templates', {
  recursive: true,
  regExp: /\.js$/
})

const TEMPLATE_PREFIX = 'templates/'

const selectWebpackContextForModulePath = modulePath => {
  const isTemplatePath = modulePath.startsWith(TEMPLATE_PREFIX)
  let webpackContext = serviceComponentsWebpackContext
  let relativeModulePath = modulePath
  if (isTemplatePath) {
    webpackContext = templateComponentsWebpackContext
    relativeModulePath = modulePath.slice(TEMPLATE_PREFIX.length)
  }

  return {
    webpackContext,
    relativeModulePath
  }
}

const findRequestPath = (webpackContext, relativeModulePath) => {
  const requestBasePath = `./${relativeModulePath}`
  const availableModuleKeys = webpackContext.keys()
  const candidateRequestPaths = [
    `${requestBasePath}.js`,
    `${requestBasePath}/index.js`
  ]

  return candidateRequestPaths.find(requestPath => {
    return availableModuleKeys.includes(requestPath)
  })
}

const resolveFromContext = (webpackContext, relativeModulePath) => {
  const matchedRequestPath = findRequestPath(webpackContext, relativeModulePath)
  if (!matchedRequestPath) {
    throw new Error(`Module not found in context: ${relativeModulePath}`)
  }

  return webpackContext(matchedRequestPath)
}

const getServiceModule = modulePath => {
  const { webpackContext, relativeModulePath } = selectWebpackContextForModulePath(modulePath)

  return resolveFromContext(webpackContext, relativeModulePath)
}

export const getServiceComponent = modulePath => {
  return getServiceModule(modulePath).default
}

/**
 * Проверяет наличие компонента сервиса в контексте сборки.
 *
 * @param {string} modulePath Путь модуля относительно корня контекста.
 * @returns {boolean} Признак наличия модуля в контексте.
 */
export const hasServiceComponent = modulePath => {
  const { webpackContext, relativeModulePath } = selectWebpackContextForModulePath(modulePath)

  return Boolean(findRequestPath(webpackContext, relativeModulePath))
}
